<script lang="ts">
	import Blok from '$lib/storyblok/blok.svelte';
	import SbRichtext from '$lib/storyblok/components/sbRichtext.svelte';
	import type { TextAlignment } from '$lib/storyblok/types';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';

	interface Props {
		headline: string | ISbRichtext;
		subline: string | ISbRichtext;
		showSublineOnMobile?: boolean;
		alignment?: TextAlignment;
		extraPadding?: boolean;
		button?: ISbStoryData['content'];
		class?: string;
	}

	let {
		headline,
		subline,
		showSublineOnMobile = true,
		alignment = 'left',
		extraPadding = false,
		button,
		class: className
	}: Props = $props();
</script>

<div
	class="flex flex-col {className || ''}"
	class:items-center={alignment === 'center'}
	class:text-center={alignment === 'center'}
	class:max-lg:px-4={extraPadding}
>
	<div
		class="text-balance text-[40px]/[110%] font-semibold tracking-[-.4px] lg:text-[52px] lg:tracking-[-.64px] xl:text-[64px]"
	>
		<SbRichtext text={headline} />
	</div>
	{#if subline}
		<div
			class="mt-4 text-balance text-[18px]/[140%] lg:mt-5 lg:text-[24px]"
			class:max-lg:hidden={!showSublineOnMobile}
		>
			<SbRichtext text={subline} />
		</div>
	{/if}

	<div class="mt-6 flex lg:mt-8">
		{#if button}
			<Blok content={button} />
		{/if}
	</div>
</div>
